/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Shop_Group_Highlight_AriaInputs */

const vi_shop_group_highlight_aria = /** @type {(inputs: Shop_Group_Highlight_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Điểm nổi bật ${i?.n}`)
};

/**

* @param {Shop_Group_Highlight_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_highlight_aria = /** @type {((inputs: Shop_Group_Highlight_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Highlight_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_highlight_aria(inputs)
});